import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setDeleteRoleError, setLoading } from "../../repository/slice";

function* deleteUsersRoleWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, "/api/user-role/delete", payload);
        if (isError) {
            yield put(setDeleteRoleError(message));
        } else {
            yield put(setDeleteRoleError(null));
        }
    } catch (error) {
        console.error("deleteUsersRoleWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteUsersRoleWatcher() {
    yield takeLatest("@saga/DELETE_USERS_ROLE", deleteUsersRoleWorker);
};
